//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React, { FC, ReactElement } from 'react'
import { Box, Tooltip, Typography } from '@mui/material'
import ViewItem from './ViewItem'

export const ViewBoolean: FC<{
  value: boolean | undefined
  label: string
  inTable: boolean
}> = ({ value, inTable, label }): ReactElement => {
  const displayValue = value ? 'true' : 'false'
  if (inTable) {
    return (
      <React.Fragment>
        <Tooltip title={value}>
          <Typography variant="bodyBold" gutterBottom component="div">
            {displayValue}
          </Typography>
        </Tooltip>
      </React.Fragment>
    )
  }
  return (
    <ViewItem>
      <Typography variant="bodyMuted" gutterBottom component="div">
        {label}
      </Typography>
      <Tooltip
        title={
          <Box
            sx={{
              display: 'flex',
              width: 350,
              flexDirection: 'column',
              border: '1px solid #dadde9',
            }}
          >
            <Typography variant="caption" color="inherit">
              {displayValue}
            </Typography>
          </Box>
        }
      >
        <Typography variant="bodyBold" gutterBottom component="div">
          {displayValue}
        </Typography>
      </Tooltip>
    </ViewItem>
  )
}
